import React from 'react';
import PropTypes from 'prop-types';
import { Seq } from 'immutable';
import { Link } from 'react-router-dom';
import get from 'lodash/get';

const propTypes = {
  bookings: PropTypes.instanceOf(Seq.Keyed),
};

const defaultProps = {
  bookings: Seq.Keyed(),
};

const ReceiptButtonsPassButton = ({ bookings }) => {
  const booking = bookings.first();

  if (get(booking, 'isMonthly', true)) {
    return null;
  }

  if (bookings.size === 1) {
    return (
      <div className="col-md-12 col-xs-10 col-xs-push-1">
        <Link
          className="btn-primary btn-block"
          to={{
            pathname: `/ticket/${booking.id}/`,
            search: `?u=${booking.authorizationCode}`,
          }}
        >
          VIEW MY PASS
        </Link>
      </div>
    );
  }

  return (
    <div className="col-md-12 col-xs-10 col-xs-push-1">
      <a className="btn-primary btn-block" href="/account">
        VIEW MY PASSES
      </a>
    </div>
  );
};

ReceiptButtonsPassButton.propTypes = propTypes;
ReceiptButtonsPassButton.defaultProps = defaultProps;
export default ReceiptButtonsPassButton;
